/**
 * Centralized Configuration Constants
 * 
 * This file contains all hardcoded configuration values used throughout the application.
 * Update values here to change them across the entire application.
 */

// ============================================
// Contact Information
// ============================================
export const CONTACT_INFO = {
  email: {
    primary: 'support@healixmw.tech',
    secondary: 'sales@healixmw.tech',
  },
  phone: {
    mobile: '+265 888 729 116',
    tel: '+265 886 790 05',
  },
  address: {
    poBox: 'P. O. Box 3105',
    city: 'Blantyre, Malawi',
  },
  businessHours: {
    days: 'Mo - Fr',
    time: '8AM - 4:30PM',
  },
};

// ============================================
// Social Media URLs
// ============================================
export const SOCIAL_MEDIA = {
  linkedin: 'https://www.linkedin.com/company/healix-medical/',
  facebook: 'https://www.facebook.com/profile.php?id=61564962316511',
  instagram: '', // Not currently used
  twitter: '', // Not currently used
};

// ============================================
// API Configuration
// ============================================
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'https://api.healix.tech/api',
  endpoints: {
    contact: '/email/contact',
  },
};

// ============================================
// Cloudinary Configuration
// ============================================
export const CLOUDINARY_CONFIG = {
  cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'dhbe6wtod',
  baseURL: 'https://res.cloudinary.com',
  videoPlayer: {
    cloudName: 'dhbe6wtod',
    embedBaseURL: 'https://player.cloudinary.com/embed/',
  },
};

// ============================================
// Application URLs
// ============================================
export const APP_URLS = {
  home: '/',
  about: '/about',
  services: '/services',
  products: '/products',
  contact: '/contact',
  blogs: '/blogs',
  testimonials: '/testimonials',
  faqs: '/contact/#faqs',
  contactForm: '/contact/#contact-form',
  partners: '/products/#products',
};

// ============================================
// Company Information
// ============================================
export const COMPANY_INFO = {
  name: 'Healix Medical',
  copyrightYear: new Date().getFullYear(),
  location: {
    city: 'Blantyre',
    country: 'Malawi',
  },
};

// ============================================
// Default Values
// ============================================
export const DEFAULTS = {
  imageQuality: 80,
  imageWidth: 800,
};
